export default "__VITE_ASSET__irSNj5GH__"